/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audio_Stems_Loaded_LabelInputs */



/**
* | output |
* | --- |
* | "Loaded: {name}" |
*
* @param {Audio_Stems_Loaded_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_loaded_label = /** @type {((inputs: Audio_Stems_Loaded_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Loaded_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Chargée : ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Geladen: ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Caricata: ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Загружено: ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Cargada: ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已加载：${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`読み込み済み：${i?.name}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लोड किया गया: ${i?.name}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Carregada: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Loaded: ${i?.name}`)
});